import "react-step-progress-bar/styles.css";
// @ts-expect-error -- no types
import { ProgressBar, Step } from "react-step-progress-bar";
import GrayCircle from "@src/assets/icons/GrayCircle.svg";
import GreenCircleWithDot from "@src/assets/icons/GreenCircleWithDot.svg";
import Circle from "@src/assets/icons/GreenCircle.svg";

const QUANITY = [1, 2, 3, 4, 5, 6, 7, 8];
interface TStep {
  accomplished: boolean;
}

const renderImg = (accomplished: boolean, isCurrent?: boolean) => {
  if (isCurrent) return GreenCircleWithDot;
  return accomplished ? Circle : GrayCircle;
};

const calcPercentage = (progress: number) => {
  if (progress === 1) return progress;
  return (100 / (QUANITY.length - 1)) * (progress - 1);
};

function StepProgressBar({ progress }: { progress: number }) {
  return (
    <ProgressBar filledBackground="#488E58" percent={calcPercentage(progress)}>
      {QUANITY.map((step) => {
        return (
          <Step key={step} transition="scale">
            {({
              accomplished, // ...props
            }: TStep) => {
              return (
                <div className="h-6 w-6">
                  <img
                    alt=""
                    className="rounded-full bg-white"
                    src={renderImg(accomplished, progress === step)}
                  />
                </div>
              );
            }}
          </Step>
        );
      })}
    </ProgressBar>
  );
}

export default StepProgressBar;
